import React from "react";
import PropTypes from "prop-types";

import Link from "components/layout/Link";
import { StyledPersonTile } from "./PersonTile/styled";
import { FontAwesomeIcon } from "../../../node_modules/@fortawesome/react-fontawesome/index";

const PersonTile = ({ image, name, onLinkClick, link, title }) => {
  return (
    <StyledPersonTile>
      <div className="person-tile__content">
        {image && (
          <div className="person-tile__image" >
            <img src={image} alt={name} />
          </div>
        )}
        <div className="person-tile__info">
          <div className="person-tile__name">{name}</div>
          {title && (
            <div className="person-tile__title">{title}</div>
          )}
          {link && (
            <div className="person-tile__footer">
              <Link
                id={`bio-open-${name}`}
                onClick={onLinkClick}
              >
                {link}

                <FontAwesomeIcon icon="arrow-right" />
              </Link>
            </div>
          )}
        </div>
      </div>
    </StyledPersonTile>
  );
};

PersonTile.propTypes = {
  name: PropTypes.string.isRequired,
  onLinkClick: PropTypes.func,
  title: PropTypes.string,
  image: PropTypes.string,
  link: PropTypes.string,
};

PersonTile.defaultPros = {
  compact: false,
  onLinkClick: null,
  title: "",
  link: "",
};

export default PersonTile;
